import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Image } from "@sparefoot/react-commons";
import { Text } from "../Typography";

import "./IconText.scss";

const IconText = ({
	src,
	alt,
	size,
	weight,
	color,
	lazyLoad,
	className,
	children
}) => (
	<div className={classnames("icon-text", `size-${size}`, `weight-${weight}`, `color-${color}`, className)}>
		<Image
			src={src}
			alt={alt}
			className="icon-text-icon"
			lazy={lazyLoad}
		/>
		<Text className="icon-text-label">{children}</Text>
	</div>
);

IconText.propTypes = {
	src: PropTypes.string.isRequired,
	alt: PropTypes.string,
	size: PropTypes.oneOf(["small", "standard", "large"]),
	weight: PropTypes.oneOf(["standard", "semiBold", "bold"]),
	color: PropTypes.oneOf(["black", "gray", "white"]),
	lazyLoad: PropTypes.bool,
	className: PropTypes.string,
	children: PropTypes.node
};

IconText.defaultProps = {
	alt: "",
	size: "standard",
	weight: "standard",
	color: "black",
	lazyLoad: false,
	className: "",
	children: null
};

export default IconText;
